import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import {
  useTakeoverThroughOccupiedBooking,
  useTakeoverThroughOriginalBooking,
} from '~components/takeover/use-takeover';
import Typography from '~components/typography';
import { SP_QueryStudentGetBookings_studentViewer_studentInfo_bookings } from '~graphql/__generated__/SP_QueryStudentGetBookings';
import { Trans, useTranslation } from '~i18n';
import { amendmentCountDown } from '~utils/count-down-time';
interface IProps {
  booking: SP_QueryStudentGetBookings_studentViewer_studentInfo_bookings;
}
const BookingCardTakeover: React.FC<IProps> = ({ booking }) => {
  const { t } = useTranslation(['student_portal']);
  const [startTime, setStartTime] = useState<any>(moment());
  const [time, setTime] = useState('00:00');

  const isTakeoverThroughOriginalBooking = useTakeoverThroughOriginalBooking(booking);
  const isTakeoverThroughOccupiedBooking = useTakeoverThroughOccupiedBooking(booking);

  const { bookingLink } = booking;
  const { countDown, sourceAcceptedAt, targetAcceptedAt } = bookingLink || {};

  useEffect(() => {
    if (countDown) {
      const leftTime = amendmentCountDown(startTime, moment(countDown));

      const timer = setInterval(() => {
        setStartTime(moment());
      }, 60000);

      if (leftTime === 0) {
        clearInterval(timer);
        setTime('00:00');
        return;
      }
      setTime(leftTime);
      return () => {
        clearInterval(timer);
      };
    }
  }, [countDown, startTime]);

  const takeoverPendingContent = useMemo(() => {
    if (
      (isTakeoverThroughOriginalBooking && sourceAcceptedAt) ||
      (isTakeoverThroughOccupiedBooking && targetAcceptedAt)
    ) {
      return <Typography variant="h9">{t('takeover.accepted_request')}</Typography>;
    }

    return (
      <>
        <Typography variant="h9">{t('There_is_a_takeover_request_for_your_booking')}</Typography>
        <Typography component="div" variant="body3" style={{ marginTop: 4 }}>
          <Trans ns="student_portal" i18nKey="takeover.booking_card_countdown">
            You have
            <Typography
              component="span"
              variant="body3"
              color="var(--color-red_6)"
              fontWeight={600}
            >
              {{ time }}
            </Typography>
            left to respond the takeover request.
          </Trans>
        </Typography>
      </>
    );
  }, [
    isTakeoverThroughOccupiedBooking,
    isTakeoverThroughOriginalBooking,
    sourceAcceptedAt,
    t,
    targetAcceptedAt,
    time,
  ]);

  return (
    <div className="booking-card-amendment">
      {takeoverPendingContent}
      <style jsx>{`
        .booking-card-amendment {
          width: 480px;
          margin-top: 20px;
          border-radius: 14px;
          padding: 12px;
          background-color: var(--color-purple_1);
        }
        @media screen and (max-width: 768px) {
          .booking-card-amendment {
            width: 100%;
            margin-top: 16px;
            padding: 8px 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default BookingCardTakeover;
